export default __webpack_public_path__ + "static/919m-hero-91c5464e6d1f324dddc651c76d8892e4.mp4";